'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'face-vomit';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e3a0';
var svgPathData = 'M496 256c0 62.4-23.8 119.3-62.9 162l14.8 7.4C487.8 380.2 512 320.9 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256c0 64.9 24.2 124.2 64 169.4L78.9 418C39.8 375.3 16 318.4 16 256 16 123.5 123.5 16 256 16S496 123.5 496 256zM117.3 163.6l7.2 3.6 81.7 40.8-81.7 40.8-7.2 3.6 7.2 14.3 7.2-3.6 96-48 4.4-2.2 0-9.9-4.4-2.2-103.2-51.6-7.2 14.3zm270.3 3.6l7.2-3.6-7.2-14.3-103.2 51.6-4.4 2.2 0 9.9 4.4 2.2 96 48 7.2 3.6 7.2-14.3-7.2-3.6-81.7-40.8 81.7-40.8zM16 512a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm496-48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM272 352a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-16 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm88-105.7c16.9 5.8 29.2 12.1 35.6 16.3l6.7 4.4 8.9-13.3-6.7-4.4C371.1 317.8 321.6 296 256 296s-115.1 21.8-132.4 33.3l-6.7 4.4 8.9 13.3 6.7-4.4c6.3-4.2 18.6-10.5 35.6-16.3l0 46.3c0 33.3-18.8 63.8-48.6 78.7l-50.9 25.5-4.4 2.2 0 32.9 384 0 0-32.9-4.4-2.2-50.9-25.5C362.8 436.5 344 406 344 372.7l0-46.3zm-16-4.9l0 51.2c0 39.4 22.3 75.4 57.5 93l46.5 23.3 0 7.1-352 0 0-7.1 46.5-23.3c35.2-17.6 57.5-53.6 57.5-93l0-51.2c20-5.4 44.4-9.5 72-9.5s52 4.1 72 9.5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceVomit = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;